/**
* @Author: zachalam
* @Date:   2017-03-15T16:25:42-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-07-31T14:25:21-07:00
*/


import React, { Component } from 'react';
import glamorous from 'glamorous';
import { css } from 'glamor';

import { spacing, dimensions, color } from '../../../style';

import Container from '../../blocks/Container';
import Button from '../../blocks/Button';
import InputGroup from '../../blocks/InputGroup';
import TextInput from '../../common/TextInput';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import Title from '../../common/Title';
import Text from '../../common/Text';
import Checkbox from '../../common/Checkbox';
import Dropzone from 'react-dropzone';
import isEmpty from 'lodash/isEmpty';
import Modal from '../../common/Modal';
import UserPhoto from './UserPhoto';
import { MAX_NUMBER_PHOTOS } from '../../../config/Master';

const PhotoList = glamorous.div({
  ':after': {
    content: '""',
    display: 'table',
    clear: 'both',
  }
});

const PhotoItem = glamorous.div({
  boxSizing: 'border-box',
  float: 'left',
  width: '100%',
  ...spacing.PADDING_SM,

  [dimensions.SCREEN_MIN_XS]: {
    width: '50%',
  },

  [dimensions.SCREEN_MIN_SM]: {
    width: '30%',
  },

  [dimensions.SCREEN_MIN_MD]: {
    width: '25%',

  }
});

const STYLES = {
  dropZone: {
    boxSizing: 'border-box',
    border: '2px dashed #bbb',
    display: 'table',
    padding: '22px',
    height: '100%',
    textAlign: 'center',
  },

  fit: {
    width: '100%',
  }
};

class Photos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPrivate: false
    }
    this.onDrop = this.onDrop.bind(this);
    this.onOpenClick = this.onOpenClick.bind(this);
    this.photoList = this.photoList.bind(this);
  }

  onDrop(acceptedFiles) {
    // submit file upload.
    var formData = new FormData();
    formData.append('private', +this.state.isPrivate);
    formData.append('photo', acceptedFiles[0]);
    this.props.uploadPhoto(formData);
  }

  onOpenClick() {
    this.dropzone.open();
  }

  photoList(photos) {
    // loop through each photo item.
    if(!isEmpty(photos)) {
      var PhotoList = Object.keys(photos).map((key) => {
        // get thumb of image
        let photo = photos[key];
        let thumb = photo.urls.profile;

        // return a block for each thumb
        // that allows user to manage photo.
        return (
          <PhotoItem key={key}>
            <UserPhoto photo={photo} thumb={thumb} theKey={key}
              makeDefault={this.props.makeDefault}
              setPrivacy={this.props.setPrivacy}
              deletePhoto={this.props.deletePhoto} />
          </PhotoItem>
        );
      })
      return PhotoList;
    }
  }

  renderDropzone(photos) {
    const noPhotos = isEmpty(photos) || false
    const canUploadMore = Boolean(photos.length < 8);

    let contents = noPhotos ?
      ( <Button variant='primary'>
          Upload Photos
        </Button>
      ) : (
        <Button>
          Add Photo
        </Button>
      )

    if(canUploadMore) {
      return (
        <PhotoItem>
          <Dropzone
            className={css(
              STYLES.dropZone,
              STYLES.fit
            ).toString()}
            ref={(node) => { this.dropzone = node; }}
            onDrop={this.onDrop}
            multiple={false}
          >
            {contents}
          </Dropzone>
        </PhotoItem>
      );
    } else {
      return null
    }
  }


  render() {
    return (
      <div>
        <Container>
          <Header>
            <Headline>Profile Photos</Headline>
          </Header>
        </Container>

        <Container>
          <PhotoList>
            {this.photoList(this.props.photos.data)}
            {this.renderDropzone(this.props.photos.data)}
          </PhotoList>
          <Text>Photos need to be larger than 400px x 400px and you should be in the photo. Please, no nudity or or revealing photos. Once uploaded, photos can take up to 48 hours to be reviewed before they are visible on your profile. Read our photo help and guidelines.</Text>
        </Container>
      </div>
    );
  }
}



export default Photos;



// WEBPACK FOOTER //
// ./src/components/pages/Photos/Photos.jsx